var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTataLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 739.33 297.09",
    style: {
      enableBackground: "new 0 0 739.33 297.09"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#007DC5;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:url(#SVGID_5_);}\n\t.st6{fill:url(#SVGID_6_);}\n\t.st7{fill:url(#SVGID_7_);}\n\t.st8{fill:url(#SVGID_8_);}\n\t.st9{fill:url(#SVGID_9_);}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "377.52,135.01 390.39,135.01 390.39,112.05 399.52,112.05 399.52,102.77 368.39,102.77  368.39,112.05 377.52,112.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "409.01,135.01 415.57,115.73 422.12,135.01 434.71,135.01 422.37,102.77 408.76,102.77  396.43,135.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "440.75,135.01 453.62,135.01 453.62,112.05 462.75,112.05 462.75,102.77 431.62,102.77  431.62,112.05 440.75,112.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "472.24,135.01 478.8,115.73 485.35,135.01 497.94,135.01 485.61,102.77 471.99,102.77 459.66,135.01  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M595.75,158.06c1.59,3.65,3.69,7.6,5.78,11.12l8.42,14.18h6.1v-32.24h-5.45v11.25 c0,4.93,0.11,9.08,0.53,13.36l-0.11,0.03c-1.49-3.5-3.36-7.25-5.49-10.8l-8.33-13.84h-6.73v32.24l5.44,0v-11.53 c0-5.29-0.08-9.55-0.31-13.74L595.75,158.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M566.52,174.25h10.24l2.92,9.11h6.32l-10.47-32.24h-7.49l-10.35,32.24h6.09L566.52,174.25z M569.97,161.84 c0.57-1.92,1.06-4.15,1.53-6.04h0.1c0.49,1.87,1.02,4.07,1.63,6.06l2.54,7.95h-8.31L569.97,161.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M470.54,178.99c-3,0-5.89-0.96-7.79-2.06l-1.31,4.88c1.76,1.08,5.3,2.06,8.71,2.06 c8.32,0,12.23-4.5,12.23-9.69c0-4.63-2.69-7.45-8.29-9.58c-4.3-1.64-6.17-2.81-6.17-5.28c0-1.9,1.59-3.88,5.33-3.88 c3.03,0,5.28,0.92,6.44,1.53l1.41-4.75c-1.68-0.85-4.24-1.59-7.73-1.59c-6.99,0-11.41,3.98-11.41,9.26c0,4.62,3.4,7.48,8.73,9.37 c4.07,1.48,5.71,2.92,5.71,5.35C476.4,177.23,474.29,178.99,470.54,178.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M385.9,155.48c2.63,0,4.78,0.58,6.28,1.26l1.28-4.69c-1.2-0.65-3.93-1.43-7.81-1.43 c-9.85,0-17.26,6.4-17.26,17c0,9.81,6.23,16.25,16.46,16.25c3.9,0,6.97-0.77,8.36-1.47l-0.97-4.64c-1.55,0.7-4.04,1.17-6.43,1.17 c-7.09,0-11.22-4.5-11.22-11.61C374.59,159.58,379.32,155.48,385.9,155.48z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "550.51,183.36 550.51,156.07 559.8,156.07 559.8,151.12 535.41,151.12 535.41,156.07 544.62,156.07  544.62,183.36  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M668.21,151.12l-3.88,8.26c-1.1,2.34-1.99,4.34-2.79,6.4h-0.1c-0.88-2.18-1.72-4.02-2.81-6.39l-3.84-8.27 h-6.74l10.2,18.82v13.42h5.89v-13.58l10.71-18.65H668.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M410.53,150.6c-9.1,0-15.35,6.99-15.35,16.89c0,9.44,5.76,16.41,14.88,16.41h0.05 c8.83,0,15.38-6.18,15.38-16.98C425.47,157.7,419.93,150.6,410.53,150.6z M410.3,179.18h-0.05c-5.63,0-8.92-5.42-8.9-11.83 c-0.01-6.43,3.09-12.04,8.97-12.04c5.88,0,8.9,5.75,8.9,11.83C419.21,173.88,415.99,179.18,410.3,179.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M638.63,155.48c2.63,0,4.78,0.58,6.28,1.26l1.28-4.69c-1.2-0.65-3.93-1.43-7.81-1.43 c-9.85,0-17.26,6.4-17.26,17c0,9.81,6.23,16.25,16.46,16.25c3.9,0,6.97-0.76,8.36-1.47l-0.97-4.64c-1.55,0.7-4.04,1.17-6.43,1.17 c-7.09,0-11.22-4.5-11.22-11.61C627.32,159.58,632.05,155.48,638.63,155.48z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "525.42,151.12 519.53,151.12 519.53,183.36 538.68,183.36 538.68,178.42 525.42,178.42  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512.83,169.54v-18.41h-5.89v18.8c0,6.32-2.55,9.23-6.79,9.23c-3.99,0-6.61-2.93-6.61-9.23v-18.8h-5.89v18.45 c0,10.14,4.85,14.33,12.28,14.33C507.72,183.9,512.83,179.47,512.83,169.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M456.1,151.12h-5.45v11.25c0,4.93,0.11,9.08,0.53,13.36l-0.11,0.03c-1.49-3.5-3.36-7.25-5.49-10.8 l-8.33-13.84h-6.73v32.24l5.45,0v-11.53c0-5.29-0.08-9.55-0.31-13.73l0.15-0.03c1.59,3.65,3.69,7.6,5.78,11.12l8.42,14.18h6.1 V151.12z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.41,
    y: 199.48,
    className: "st0",
    width: 5.89,
    height: 32.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M434.92,216.6v-0.13c3.01-1.07,5.81-3.87,5.81-7.99c0-2.74-1-4.96-2.75-6.42c-2.16-1.8-5.88-2.58-9.87-2.58 c-3.99,0-6.63,0.28-8.86,0.69l0,31.55h5.8v-13.15h2.94c3.32,0.08,4.84,1.43,5.76,5.6c0.89,3.98,1.66,6.62,2.15,7.55h6 c-0.64-1.25-1.51-4.92-2.52-8.92C438.58,219.69,437.24,217.48,434.92,216.6z M428.51,214.28h-3.46v-10.11 c0.59-0.15,1.78-0.29,3.63-0.29c3.78,0.01,6.23,1.64,6.23,5.13C434.91,212.19,432.47,214.28,428.51,214.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M460.97,214.22c-1.25,3.91-2.42,7.85-3.28,11.65h-0.1c-0.84-3.9-1.94-7.67-3.16-11.74l-4.4-14.66h-6.42 l10.43,32.24h6.75l11.14-32.24h-6.27L460.97,214.22z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "522.05,217.41 534.2,217.41 534.2,212.61 522.05,212.61 522.05,204.32 534.92,204.32 534.92,199.48  516.16,199.48 516.16,231.71 535.63,231.71 535.63,226.87 522.05,226.87  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M503.87,203.83c2.63,0,4.78,0.58,6.28,1.26l1.28-4.69c-1.2-0.65-3.93-1.43-7.81-1.43 c-9.85,0-17.26,6.4-17.26,17c0,9.81,6.23,16.25,16.46,16.25c3.9,0,6.97-0.76,8.36-1.47l-0.97-4.64c-1.56,0.7-4.04,1.17-6.43,1.17 c-7.09,0-11.22-4.5-11.22-11.61C492.56,207.93,497.29,203.83,503.87,203.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M381.04,212.95c-4.31-1.64-6.17-2.81-6.17-5.28c0-1.9,1.59-3.88,5.32-3.88c3.03,0,5.28,0.92,6.44,1.53 l1.41-4.75c-1.68-0.85-4.24-1.59-7.73-1.59c-6.99,0-11.41,3.98-11.41,9.26c0,4.62,3.4,7.48,8.73,9.37 c4.07,1.48,5.71,2.92,5.71,5.35c0,2.64-2.1,4.4-5.86,4.4c-3,0-5.89-0.96-7.79-2.06l-1.31,4.88c1.76,1.08,5.3,2.06,8.71,2.06 c8.32,0,12.23-4.5,12.23-9.69C389.33,217.9,386.64,215.08,381.04,212.95z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "400.51,217.41 412.66,217.41 412.66,212.61 400.51,212.61 400.51,204.32 413.39,204.32  413.39,199.48 394.62,199.48 394.62,231.71 414.1,231.71 414.1,226.87 400.51,226.87  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M552.03,212.95c-4.3-1.64-6.17-2.81-6.17-5.28c0-1.9,1.59-3.88,5.32-3.88c3.03,0,5.28,0.92,6.44,1.53 l1.41-4.75c-1.68-0.85-4.24-1.59-7.73-1.59c-6.99,0-11.41,3.98-11.41,9.26c0,4.62,3.4,7.48,8.73,9.37 c4.07,1.48,5.71,2.92,5.71,5.35c0,2.64-2.1,4.4-5.86,4.4c-3,0-5.89-0.96-7.79-2.06l-1.31,4.88c1.76,1.08,5.3,2.06,8.71,2.06 c8.32,0,12.23-4.5,12.23-9.69C560.32,217.9,557.63,215.08,552.03,212.95z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.4531,
    y1: 70.8968,
    x2: 76.4531,
    y2: 119.0746
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC708"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    style: {
      stopColor: "#F05731"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F05731"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.77,124.82c0-14.6,9.49-23.36,23.36-23.36V76.64c0-7.3-4.87-12.17-11.68-12.17s-11.68,4.87-11.68,12.17 V124.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.9352,
    y1: 107.9182,
    x2: 90.3363,
    y2: 199.0745
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F80000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE3984"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.14,232.61c5.84,0,11.19-0.97,16.06-2.68c-24.58,4.14-34.07-12.65-34.07-31.63v-77.86h28.47 c6.57,0,10.95-3.89,10.95-9.49c0-5.6-4.38-9.49-10.95-9.49H88.13c-13.87,0-23.36,8.76-23.36,23.36v66.91 C64.77,218.5,80.1,232.61,106.14,232.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.4423,
    y1: 215.7541,
    x2: 151.4033,
    y2: 194.8241
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE3984"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    style: {
      stopColor: "#7800DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7800DA"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M122.2,229.93c9.73-3.65,17.28-10.46,22.14-20.44l-10.95-19.71c-4.87,14.6-13.38,22.39-25.06,22.39 c-12.17,0-20.2-7.06-20.2-23.12v9.25C88.13,217.28,97.62,234.07,122.2,229.93z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.1055,
    y1: 133.2115,
    x2: 199.2066,
    y2: 218.1998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#EE3984"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE3984"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M222.2,226.04c-55.48,8.27-73-21.41-73-59.61c0-27.74,17.03-46.72,41.61-46.72c9,0,16.55,1.95,23.36,5.11 c3.16,1.46,5.84,1.95,8.27,1.95c5.84,0,9.73-3.89,9.73-9.73c0-3.65-2.19-7.3-7.3-9.73c-9.25-4.62-21.17-7.3-34.07-7.3 c-38.45,0-64.97,27.25-64.97,66.91c0,38.93,25.55,65.94,66.67,65.94C203.71,232.85,213.44,230.66,222.2,226.04z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.8477,
    y1: 133.4574,
    x2: 232.1797,
    y2: 133.4574
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC708"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA3B00"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M125.85,166.91c0-39.66,26.52-66.91,64.97-66.91c12.9,0,24.82,2.68,34.07,7.3c5.11,2.43,7.3,6.08,7.3,9.73 c0,5.84-3.89,9.73-9.73,9.73c-2.43,0-5.11-0.49-8.27-1.95c-8.27-3.89-16.3-5.11-23.36-5.11 C156.99,119.71,125.85,141.12,125.85,166.91z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.6752,
    y1: 164.9678,
    x2: 333.1587,
    y2: 164.9678
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE3984"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M271.11,107.79c-2.19,2.19-3.41,4.87-3.41,8.03c0,8.03,7.54,19.95,25.06,32.12l19.95,13.87 c14.6,10.22,20.44,19.95,20.44,34.55c0,10.46-4.14,19.47-10.95,25.79c2.43-2.19,3.89-5.11,3.89-9c0-8.52-8.52-21.9-26.77-34.55 l-18.25-12.65c-15.33-10.71-21.41-20.68-21.41-34.31c0-8.03,2.92-15.33,7.79-20.68C268.68,109.73,269.89,108.76,271.11,107.79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.9508,
    y1: 200.4353,
    x2: 254.2583,
    y2: 217.5598
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE3984"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7800DA"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M255.3,217.04c0,3.89,1.95,7.06,7.06,9.49c7.06,3.41,18.49,6.33,28.71,6.33c12.9,0,23.6-3.89,31.15-10.71 c2.43-2.19,3.89-5.11,3.89-9c0-8.52-8.52-21.9-26.77-34.55c8.27,5.84,11.68,10.71,11.68,17.76c0,10.46-8.27,17.52-20.2,17.52 c-11.44,0-21.17-5.84-26.52-5.84C258.95,208.04,255.3,211.69,255.3,217.04z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.7049,
    y1: 123.9679,
    x2: 329.5089,
    y2: 123.9679
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC708"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F05731"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F05731"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M292.77,147.94c-7.79-5.6-11.19-10.71-11.19-16.79c0-7.79,6.33-12.65,15.33-12.65 c11.44,0,16.79,5.35,23.6,5.35c5.35,0,9-3.65,9-9c0-3.89-1.95-7.06-7.06-9.49c-8.03-3.89-16.79-5.35-26.28-5.35 c-9.98,0-18.74,2.92-25.06,7.79c-2.19,2.19-3.41,4.87-3.41,8.03C267.7,123.85,275.25,135.77,292.77,147.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 186.6893,
    y1: 202.9795,
    x2: 231.7204,
    y2: 129.4077
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE3984"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7800DA"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M149.21,166.43c0,38.2,17.52,67.89,73,59.61c17.76-9.25,30.42-27.98,39.17-56.69l5.11-16.79 c-4.87-6.33-6.81-13.38-6.81-20.93c0-8.03,2.92-15.33,7.79-20.68c-7.3,7.79-13.38,19.22-18.25,35.28l-5.6,18.49 c-9.98,32.61-25.79,48.18-50.37,48.18C166.24,212.9,149.21,194.17,149.21,166.43z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTataLogo);
export default __webpack_public_path__ + "static/media/Tata_Logo.6094ef596d3bcebc7d79ef9e3c97df7a.svg";
export { ForwardRef as ReactComponent };